export const service = {
  default: '/sys',
  report: '/report',
  process: '/activiti',
  upload: '/upload',
  uploads: '/uploads',
  createCode: '/createFile',
  sys: '/sys',
  back: '/back',
  mobile: '/mobile'
}
